import { render, staticRenderFns } from "./LessonMessages.vue?vue&type=template&id=603e49cd&scoped=true&"
import script from "./LessonMessages.vue?vue&type=script&lang=js&"
export * from "./LessonMessages.vue?vue&type=script&lang=js&"
import style0 from "./LessonMessages.vue?vue&type=style&index=0&id=603e49cd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603e49cd",
  null
  
)

export default component.exports